import React from 'react';

const LogoMark = ({ showText = true, onClick }) => (
  <div className="nlg" onClick={onClick} style={onClick ? { cursor: 'pointer' } : { cursor: 'default' }}>
    <div className="nlm">
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="14" width="4" height="5" rx="1" fill="#fff" />
        <rect x="8" y="10" width="4" height="9" rx="1" fill="#fff" />
        <rect x="14" y="5" width="4" height="14" rx="1" fill="#fff" />
      </svg>
    </div>
    {showText && (
      <span className="nln">
        Strat<span>X</span>
      </span>
    )}
  </div>
);

export default LogoMark;
